import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { SafeLiftService } from 'src/app/services/app/safelift.service';
import { App_FormBloc, App_FormCreatorJson, App_FormSketchFormDynamique, App_FormStep } from 'src/app/utils/interfaces';
import { Type_App_Validator, Type_FieldOrLabel } from 'src/app/utils/types';
import { instanceOfTrueField } from 'src/app/utils/utils';

@Component({
  selector: 'app-c-all-fields',
  templateUrl: './c-all-fields.component.html',
  styleUrls: ['./c-all-fields.component.scss'],
})
export class CAllFieldsComponent implements OnInit {
  @Input({ required: true }) modeShow!: boolean;
  @Input({ required: true }) forms!: FormGroup;
  @Input({ required: true }) blocName!: string;
  @Input({ required: true }) fieldOrLabel!: Type_FieldOrLabel;

  @Input({ required: true }) display!: App_FormCreatorJson; // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) context!: 'preparation' | 'edition'; // TODO-pf? retirer + remplacer quand et si pertinent

  @Input({ required: true }) observeSourcesArrFromParentPage!: { formControl: FormControl; validator: Type_App_Validator; }[]; // TODO-pf? retirer + remplacer quand et si pertinent

  @Input() etatId?: number;
  @Input({ required: true }) step!: App_FormStep // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) bloc!: App_FormBloc // TODO-pf? retirer + remplacer quand et si pertinent

  @Input({ required: true }) mainFormOrSubForm!: 'main-form' | 'sub-form'

  @Output() triggerAlert = new EventEmitter<{ data: string }>();

  @Output() fieldSketchFormArraySubGroupEditor = new EventEmitter<{ formSketchFormDynamique: App_FormSketchFormDynamique, formGroup: FormGroup, blocName: string, step: App_FormStep, bloc: App_FormBloc }>();

  previousField: AbstractControl | true | undefined;

  constructor(
    private safeLiftService: SafeLiftService
  ) { }

  cascadeTriggerAlert($event: any) {
    this.triggerAlert.emit($event);
  }

  cascadeFormArraySubGroupEditor($event: { formSketchFormDynamique: App_FormSketchFormDynamique, formGroup: FormGroup, blocName: string, step: App_FormStep, bloc: App_FormBloc }) {
    this.fieldSketchFormArraySubGroupEditor.emit($event)
  }

  ngOnInit() {
    this.behaviorIfPrevious()
  }

  /**
   * Cherche à savoir si le champ nécessite la validation du champ précédent pour que l'utilisateur puisse interagir avec
   * Auquel cas, le recherche et le set dans la variable previousField fournie au composant c-field-status qui traitera l'info
   * Si on ne trouve rien, on le set à true (car le c-field-status ne s'affiche que si previousField est setté)
   */
  behaviorIfPrevious() {
    if (this.fieldOrLabel.type === 'field' && this.fieldOrLabel.pre_requis) {
      const previousFieldName = this.findPreviousFieldName()
      if (previousFieldName) {
        const previousField = this.findPreviousFieldWithName(previousFieldName);
        if (previousField) {
          this.previousField = previousField;
          return;
        }
      }
    }
    this.previousField = true
  }

  findPreviousFieldName(): string | undefined {
    // D'abord, on cherche à savoir si le champ est le premier du bloc 
    const blocFieldsOnly = this.bloc.fields.filter(fieldOrLabel => instanceOfTrueField(fieldOrLabel));
    const indexInBloc = blocFieldsOnly.findIndex(fL => fL === this.fieldOrLabel);
    if (indexInBloc !== -1) {
      if (indexInBloc === 0) { // Si le champ est le premier du bloc
        // On cherche à savoir si on est dans le premier bloc
        const blocIndexInStep = this.step.blocs.findIndex(b => b === this.bloc);
        if (blocIndexInStep !== -1 && blocIndexInStep !== 0) { // Si le bloc n'est pas le premier du step
          const reversedStepListOfPreviousBlocs = this.step.blocs.slice(0, blocIndexInStep).reverse(); // On part du bloc précédent, et on boucle en descendant jusqu'à trouver
          for (const bloc of reversedStepListOfPreviousBlocs) {
            const reversedBlocListOfFieldsOnly = bloc.fields.filter(fieldOrLabel => instanceOfTrueField(fieldOrLabel)).reverse(); // On part du dernier champ qui est de type champ
            const first = reversedBlocListOfFieldsOnly.length > 0 ? reversedBlocListOfFieldsOnly[0] : undefined
            if (first && typeof first.name === 'string') { // On s'arrête au premier champ existant et on récupère son nom
              return first.name;
            }
          }
        } // Sinon, on ne retourne rien
      } else { // Si le champ n'est pas le premier du bloc, on retourne le nom du champ précédent
        const previousfieldInSameBlock = blocFieldsOnly[indexInBloc - 1]
        if (previousfieldInSameBlock && typeof previousfieldInSameBlock.name === 'string') {
          return previousfieldInSameBlock.name
        }
      }
    }
    return undefined;
  }

  /**
   * Récupère l'entité AbstractForm correspondant au name fourni
   */
  findPreviousFieldWithName(name: string) {
    
    return this.safeLiftService.findFieldInFormEntity(this.forms, name);
  }
}
